import React from "react";
import GenAIPractitioner from "../common/GenAIPractitioner";

const destinations = [
  { path: "/LearnToCode", title: "Learn to code", label: "START HERE", description: "Browsable Q&As and practical notes for developers.", image: "/images/code.png" },
  { path: "/AWSDedication", title: "CloudOpsGuru", label: "CLOUD", description: "AWS learning notes, services, and certification preparation.", image: "/images/aws_new.jpg" },
  { path: "/Opensource", title: "Open source", label: "BUILD IN PUBLIC", description: "Explore projects and tools worth learning from.", image: "/images/opensource.png" },
  { path: "/Microsoft", title: "Microsoft", label: ".NET", description: "Cross-platform notes and .NET Core resources.", image: "/images/microsoft.jpg" },
  { path: "/GIT", title: "Git it", label: "WORKFLOW", description: "Version-control concepts and references for everyday work.", image: "/images/github.gif" }
];

export default function HomeCodeAndTech() {
  return (
    <>
      <section className="page-intro home-hero">
        <p className="page-kicker">CODE • CLOUD • CURIOSITY</p>
        <h1>Learn the things that make ideas real.</h1>
        <p>Practical developer notes, cloud know-how, and useful starting points—collected in one place.</p>
        <div className="hero-actions">
          <a className="button button--primary" href="#/LearnToCode">Explore learning notes <span>→</span></a>
          <a className="button button--quiet" href="#/AWSDedication">CloudOpsGuru</a>
        </div>
      </section>

      <section className="destination-grid" aria-label="Explore CodeAndTech">
        {destinations.map((item, index) => (
          <a className={`destination-card destination-card--${index + 1}`} href={`#${item.path}`} key={item.path}>
            <span className="destination-card__topline">{item.label}<span aria-hidden="true">↗</span></span>
            <div className="destination-card__body">
              <h2>{item.title}</h2>
              <p>{item.description}</p>
            </div>
            <img src={item.image} alt="" />
          </a>
        ))}
      </section>

      <section className="home-section home-section--ai">
        <div className="section-heading">
          <p className="page-kicker">CURRENT FOCUS</p>
          <h2>AWS Certified AI Practitioner</h2>
          <p>Exam notes and service-level revision material, kept alongside the rest of the learning library.</p>
        </div>
        <GenAIPractitioner />
      </section>
    </>
  );
}
